export interface IIntegration {
  clientId: string;
  clientName: string;
  clientUri: string;
  logoUri: string | null;
  description: string;
  redirectUris: string[];
  allowedScopes: string[] | null;
  clientSecrets: string[] | null;
  properties: IntegrationProperties;
}

interface IntegrationProperties {
  isPublicApi: string;
}

export interface UscIntegrationDates {
  clientId: string;
  providerId: string;
  startDate: string;
  endDate: string;
}

export interface IntegrationDateObject {
  startDate: string;
  endDate: string;
  initialStartDate: string;
  initialEndDate: string;
}

export enum IntegrationValues {
  Integrations = 'integrations',
  StartDate = 'Start date',
  EndDate = 'End date',
}
